import {
  isAndroid,
  isIOS,
  isMobile,
  isMobileSafari,
  isSafari,
} from "react-device-detect";
import analytics from "utils/analytics/analytics";

const LINK_PRESTADOR_ANDROID =
  "intent:#Intent;scheme=prontlife-prestador://app;package=br.com.prontlife.prestador;end";
const LINK_PRESTADOR_IOS = "itms-appss://itunes.apple.com/app/id1489353060";

const LINK_BENEFICIARIO_ANDROID =
  "intent:#Intent;scheme=prontlife://app;package=br.com.prontlife.prontlife;end";
const LINK_BENEFICIARIO_IOS = "itms-appss://itunes.apple.com/app/id1232794171";

const storeLink = ({
  apple_url,
  google_url,
}: {
  apple_url: string;
  google_url: string;
}) => {
  if (isIOS || isMobileSafari || isSafari) {
    return apple_url;
  }

  if (isAndroid) {
    return google_url;
  }

  if (!isAndroid && !isIOS) {
    return "https://app.prontlife.com.br/prontlife-web/cadastro/";
  }
};

export const sendAnalyticEventWhatsapp = () => {
  if (isMobile) {
    analytics.sendEvent({
      category: "Contact",
      action: "WhatsApp",
      label: "Mobile",
    });
  } else {
    analytics.sendEvent({
      category: "Contact",
      action: "WhatsApp",
      label: "Web",
    });
  }
};

export const sendAnalyticEvent = () => {
  if (isIOS) {
    analytics.sendEvent({
      category: "Store",
      action: "Download",
      label: "Apple",
    });
    return;
  }

  if (isAndroid) {
    analytics.sendEvent({
      category: "Store",
      action: "Download",
      label: "Google",
    });
    return;
  }

  analytics.sendEvent({
    category: "Store",
    action: "Download",
    label: "Web",
  });
};

export const appPrestadorStoreLink = () =>
  storeLink({
    google_url: LINK_PRESTADOR_ANDROID,
    apple_url: LINK_PRESTADOR_IOS,
  });

export const appBeneficiarioStoreLink = () =>
  storeLink({
    google_url: LINK_BENEFICIARIO_ANDROID,
    apple_url: LINK_BENEFICIARIO_IOS,
  });

export const storeBeneficiarioButtonLink = () => {
  const links = {
    ios: {
      intent_url: LINK_BENEFICIARIO_IOS,
      web_url: "https://apps.apple.com/br/app/prontlife/id1232794171",
    },
    android: {
      intent_url: LINK_BENEFICIARIO_ANDROID,
      web_url:
        "https://play.google.com/store/apps/details?id=br.com.prontlife.prontlife",
    },
  };

  let link = {
    ios: links.ios.web_url,
    android: links.android.web_url,
  };

  if (!isMobile) {
    analytics.sendEvent({
      category: "Store",
      action: "Download",
      label: "Web",
    });
    return link;
  }

  if (isIOS || isMobileSafari) {
    analytics.sendEvent({
      category: "Store",
      action: "Download",
      label: "Google",
    });
    link.ios = links.ios.intent_url;
  }

  if (isAndroid) {
    analytics.sendEvent({
      category: "Store",
      action: "Download",
      label: "Google",
    });
    link.android = links.android.intent_url;
  }
  return link;
};
